export default __webpack_public_path__ + "FuturaLT.ttf";